module.exports = __webpack_public_path__ + "static/img/tax.e6d17e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tax.png
// module id = UGhT
// module chunks = 1